import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Radio, Space } from 'antd';

import { parseStringOr, moneyFormat } from '../../helpers/AppxUtils';
import { TvPlanContext } from '../../contexts/tvplancontext';
import TvService from '../TvService';

import './index.css';


export default function TvPickGroupPack(props) {
    const ctx = useContext(TvPlanContext);
    const cfg = ctx.getTvConfig();
    const [ loading, setLoading ] = useState(true);
    const [ options, setOptions ] = useState([]);
    const [ group, setGroup ] = useState('none');
    const [ selected, setSelected ] = useState([]);
    const cfgChannels = cfg.channels || {};
    const fixedPicks = cfg.fixedPicks || {};
    const { t } = useTranslation('tvplan');
    const onChange = (gcode) => {
        ctx.resetPickGroup();
        setSelected([]);
        setGroup(gcode);
    };
    const onSelect = async(item, xgroup) => {
        const selected = await ctx.isServicePickGoupSelected(item, xgroup.code);
        let sels = [];
        if (selected) {
            sels = await ctx.unselectPickGroup(item, xgroup);
        }
        else {
            sels = await ctx.selectPickGroup(item, xgroup);
        }

        setSelected([...sels]);
    };

    useEffect(() => {
        async function fetchOptions() {
            setLoading(true);
            let aux = [];

            for (let key in fixedPicks) {
                let fp = fixedPicks[key];
                let services = await ctx.parsePickGoupServices(fp);

                if (services.length >= fp?.pickCount) {
                    let option = {
                        code: key,
                        des: t('tvreview_pick_pack_item', {unit: fp.pickCount, price: moneyFormat(fp.price)}),
                        price: fp.price,
                        pickCount: fp.pickCount,
                        services: [],
                    };

                    for (let code of services) {
                        option.services.push({
                            code: code,
                            des: parseStringOr(cfgChannels[code]?.des, code),
                        });
                    }

                    aux.push(option);
                }
            }

            setOptions(aux);
            setLoading(false);
        }

        // preload when it comes from ispx
        if (ctx.mustUpdate < 1) {
            let gcode = 'none';
            let services = [];

            for (let key in fixedPicks) {
                if (ctx.isPickGoupSelected(key)) {
                    gcode = key;
                    let pickFromService = fixedPicks[key]?.pickFromService || [];

                    for (let scode of pickFromService) {
                        if (ctx.isServicePickGoupSelected(scode, key)) {
                            services.push(scode);
                        }
                    }
                }
            }

            setGroup(gcode)
            setSelected(services);
        }
        else {
            onChange('none');
        }

        fetchOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ctx.mustUpdate]);

    if (loading) {
        return null;
    }

    return (
        <div className="tv-pick-group-pack">
            <div className="tv-pick-group-name">
                {t('TvPickStepPickGroupPack.label')}
            </div>
            <div className="tvpgp-options">
                <Radio.Group
                    onChange={(e) => onChange(e?.target?.value||"none")}
                    value={group}>
                    <Space direction="horizontal">
                        <Radio
                            key={`group-pick-none-0`}
                            value="none"
                            className="none-option">
                            {t('None')}
                        </Radio>
                        {options.map((item, idx) => (
                        <Radio
                            key={`group-pick-${item.code}-${idx}`}
                            value={item.code}>
                            <span dangerouslySetInnerHTML={{__html: item.des}} />
                        </Radio>
                        ))}
                    </Space>
                </Radio.Group>
                {options.map((item, idx) => (
                <div
                    key={`group-pick-${item.code}-${idx}-cnt`}
                    className="tv-plan-services"
                    style={{
                        clear: 'both',
                        marginTop: 24,
                        display: item.code === group ? 'block' : 'none',
                    }}>
                    {item.services.map(ch => (
                    <TvService
                        key={`group-pick-${item.code}-${idx}-svc-${ch.code}`}
                        code={ch.code}
                        groupCode={item.code}
                        onClick={() => onSelect(ch.code, item)}
                        selected={(selected.indexOf(ch.code) > -1)}
                        removeIfInStarter={true}
                        pickMode={props.pickMode}
                        myPriceChoice={(selected.length !== item.pickCount) ? "standalone" : null}
                        showPrice={false} />
                    ))}
                </div>
                ))}
            </div>
        </div>
    );
}